import { SPONSORSHIP_TYPES, type SponsorshipType } from "./sponsorship";

export const SPONSOR_BANNER_HEIGHT_CLASS = "[height:var(--sponsorBarHeight)]";

export const TRANSPARENT_PIXEL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII";

export const SEO_SIFTED_ON_PINK_IMAGE =
  "https://images.sifted.eu/wp-content/uploads/2019/02/25140415/sifted-on-pink.png?w=1200&h=628&q=75&fit=crop&auto=compress,format";

export const newsletterToPropMapping = {
  upround: "would-like-futureproof-newsletter",
  climatetech: "would-like-sustainability-newsletter",
  startuplife: "would-like-startup-life-newsletter",
  fintech: "would-like-fintech-newsletter",
  sifted: "wants_main_newsletter",
  deeptech: "would-like-deeptech-newsletter",
  pro: "would-like-member-newsletter",
  scoop: "would-like-scoop-newsletter",
};

export { SPONSORSHIP_TYPES };
export type { SponsorshipType };

export const JOIN_TO_ACCESS_TEXT = "Join to access";
